import { createFileRoute, useRouter } from '@tanstack/react-router';
import QRCode from 'react-qr-code';
import usePatientDoc from '../../../../hooks/usePatientDoc';
import { PatientDoc } from '../../../../types/Patient/PatientDoc';
import { Heading } from '../../../../components/Heading';
import { Button } from '../../../../components';

export const Route = createFileRoute('/_authenticated/$patientId/photos/qrInstructions')({
  component: QRInstructions,
});

function QRInstructions() {
  const router = useRouter();
  const { patientId } = Route.useParams<{ patientId: string }>();
  const patientDocQuery = usePatientDoc(patientId);
  const patientInfo = patientDocQuery.data as PatientDoc;
  if (!patientInfo) {
    return <div>Loading...</div>;
  }
  return (
    <div id="instructions-container" className="flex flex-col items-center justify-center">
      <Heading id="qr-instructions-header" textContent="Mobile Upload Instructions" />
      <div className="flex flex-row items-center">
        <div id="qrInstructions" className="mx-4 flex w-1/2 flex-col items-center justify-center">
          {patientInfo.enrollmentInfo ? (
            <img src="/bulkUserQRInstructions.png" alt="Sample QR Code" className="h-auto" />
          ) : (
            <img src="/passageUserQRInstructions.png" alt="Sample QR Code" className="h-auto" />
          )}
        </div>
        <div className="mx-4 flex w-1/2 flex-col items-center justify-center">
          <QRCode
            // size={200}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            value={`${import.meta.env.VITE_PORTAL_BASE_URL}/${patientId}/capture/id`}
            viewBox={`0 0 200 200`}
          />
        </div>
      </div>
      <Button
        id="qr-instructions-back-button"
        onClick={() => {
          router.history.back();
        }}
        textContent="Go Back"
        type="button"
      />
    </div>
  );
}
